module.exports = __webpack_public_path__ + "img/schlosserei-raichle-logo-slogan.0c974519.png";